import { useMemo } from 'react'
import lodash from 'lodash'
import { useLocation } from 'react-router-dom'

import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import useMyhouse from '@Hooks/myhouse/useMyhouse'
import useUser from '@Hooks/user/useUser'
import { getDeniedPath, LAND_DENIED_TYPE } from '@Root/contants/myhouseError'

const useMainRedirect = () => {
  const location = useLocation()
  const path = location.pathname

  const { user, login } = useUser()
  const { myhouse } = useMyhouse()

  const redirectPath = useMemo(() => {
    if (lodash.startsWith(path, LAND_SERVICE_PREFIX_URL.MYHOUSE_INTRODUCE) || lodash.startsWith(path, LAND_SERVICE_PREFIX_URL.MYHOUSE_DENIED)) {
      return path
    }

    if (lodash.includes(path, LAND_SERVICE_PREFIX_URL.MYHOUSE) && !user.isLogin) {
      return login() || getDeniedPath(LAND_DENIED_TYPE.NOT_LOGIN)
    }

    return path
  }, [path, user.isLogin, myhouse])

  const mainRedirect = useMemo(() => {
    return lodash.isEmpty(redirectPath) || path === redirectPath ? undefined : { from: path, to: redirectPath }
  }, [path, redirectPath])

  return { mainRedirect }
}

export default useMainRedirect
